import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { servicesService } from '@/services/ServicesService'
import { companiesService } from '@/services/CompaniesService'

export const useServicesStore = defineStore('services', () => {
  // State
  const services = ref([])
  const isLoading = ref(false)
  const error = ref(null)

  // Getters
  const activeServices = computed(() => 
    services.value.filter(service => service.isActive ?? service.is_active ?? true)
  )

  const serviceCount = computed(() => services.value.length)

  const getServiceById = computed(() => (id) => 
    services.value.find(service => service.id === id)
  )

  const averagePrice = computed(() => {
    if (services.value.length === 0) return 0
    const total = services.value.reduce((sum, service) => sum + Number(service.price), 0)
    return Math.round(total / services.value.length)
  })

  // Actions
  async function fetchServices() {
    if (!companiesService.hasActiveCompany()) {
      services.value = []
      return
    }
    isLoading.value = true
    error.value = null
    try {
      const response = await servicesService.getAll()
      services.value = response.data || response || []
      console.log('Servicios cargados desde API:', services.value.length)//LIMPIAR CONSOLE LOGS
    } catch (err) {
      error.value = 'Error al cargar servicios'
      console.error('Error fetching services:', err)
    } finally {
      isLoading.value = false
    }
  }

  async function addService(serviceData, companyId) {
    try {
      const response = await servicesService.create(companyId, serviceData)
      const newService = response.data || response
      services.value.push(newService)
      console.log('Servicio agregado:', newService.name)//LIMPIAR CONSOLE LOGS
      return newService
    } catch (err) {
      console.error('Error adding service:', err)
      throw err
    }
  }

  async function updateService(id, companyId, serviceData) {
    try {
      const response = await servicesService.update(id, companyId, serviceData)
      const updatedService = response.data || response
      const index = services.value.findIndex(s => s.id === id)
      if (index !== -1) {
        services.value[index] = updatedService
      }
      console.log('Servicio actualizado:', updatedService.name)//LIMPIAR CONSOLE LOGS
      return updatedService
    } catch (err) {
      console.error('Error updating service:', err)
      throw err
    }
  }

  async function deleteService(id) {
    try {
      await servicesService.delete(id)
      services.value = services.value.filter(s => s.id !== id)
      console.log('Servicio eliminado:', id)//LIMPIAR CONSOLE LOGS
    } catch (err) {
      console.error('Error deleting service:', err)
      throw err
    }
  }

  async function toggleServiceStatus(id) {
    const service = services.value.find(s => s.id === id)
    if (service) {
      const isActive = service.isActive ?? service.is_active ?? true
      const response = isActive
        ? await servicesService.deactivate(id)
        : await servicesService.reactivate(id)
      const updatedService = response?.data || response
      service.isActive = updatedService?.isActive ?? updatedService?.is_active ?? !isActive
      service.is_active = updatedService?.is_active ?? updatedService?.isActive ?? !isActive
      return service
    }
    throw new Error('Servicio no encontrado')
  }

  function $reset() {
    services.value = []
    isLoading.value = false
    error.value = null
  }

  return {
    services,
    isLoading,
    error,
    activeServices,
    serviceCount,
    getServiceById,
    averagePrice,
    fetchServices,
    addService,
    updateService,
    deleteService,
    toggleServiceStatus,
    $reset
  }
})
